import axios from "axios";
import React from "react";

import HalftimeChart1 from "./halftime_chart1";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { Link } from "react-router-dom";

import { translate } from "react-i18next";

import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// See https://facebook.github.io/react/docs/forms.html for documentation about forms.
class MedicationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drugsplanned: []
    };
  }

  actionTemplate2(rowData, column) {
    return (
      <HalftimeChart1
        name="name1"
        count="4"
        starttime="9"
        drugplanned={rowData}
      />
    );
  }
  componentDidMount() {
    const data = {
      drugsplanned: [
        {
          id: 15,
          datetime_intake_planned: 1567407600000,
          drug: {
            id: 1,
            name: "Accupro® 10 Filmtabletten",
            packaging: [{}, {}],
            packagingSection: [{}, {}, {}, {}, {}, {}, {}],
            activeSubstance: [{}],
            pharmaceuticalForm: [{}],
            productGroup: {},
            indicationGroup: {},
            disease: [{}, {}],
            drugFeature: [{}, {}, {}, {}],
            drug_image: {},
            year: "2011-01-01",
            status: "3915-06-01",
            version: "1.59",
            period: 2
          },
          user: {
            id: 2,
            firstname: "Christina",
            lastname: "Speck",
            username: "cs",
            email: "cs@test.de",
            dateOfBirth: "1995-09-18",
            dateOfRegistration: 1567332000000,
            levelOfDetail: 3,
            country: {},
            language: {},
            gender: {}
          }
        },
        {
          id: 16,
          datetime_intake_planned: 1567422000000,
          drug: {
            id: 2,
            name: "Baymycard",
            packaging: [{}, {}],
            packagingSection: [{}, {}, {}, {}, {}, {}, {}, {}],
            activeSubstance: [{}],
            pharmaceuticalForm: [{}],
            productGroup: {},
            indicationGroup: {},
            disease: [{}],
            drugFeature: [{}, {}, {}, {}, {}, {}],
            drug_image: {},
            year: "2011-01-01",
            status: "3915-06-01",
            version: "1.59",
            period: 3
          },
          user: {
            id: 2,
            firstname: "Christina",
            lastname: "Speck",
            username: "cs",
            email: "cs@test.de",
            dateOfBirth: "1995-09-18",
            dateOfRegistration: 1567332000000,
            levelOfDetail: 3,
            country: {},
            language: {},
            gender: {}
          }
        }
      ]
    };

    this.setState(data);
  }

  // for html conversion
  createMarkup(text) {
    return { __html: text };
  }

  //<Column body={this.actionTemplate.bind(this)} header="Actions" />
  render() {
    return (
      <div className="container marketing no-banner">
        <div className="page-header">
          <div className="btn-toolbar pull-right">
            <div className="btn-group" />
          </div>
          <h3>Test medication plan</h3>
        </div>

        <div>
          <DataTable value={this.state.drugsplanned}>
            <Column body={this.actionTemplate2.bind(this)} header="Halftime" />
            <Column field="drug.name" header="drug" />
            <Column field="datetime_intake_planned" header="intake planned" />
          </DataTable>
        </div>

        <br />
        <HalftimeChart1
          name="name3"
          count="4"
          starttime="9"
          drugplanned={this.state.drugsplanned[0]}
        />
      </div>
    );
  }
}

export default translate()(MedicationList);
